/* MJ personalisation capture fix (Sept 2026)
 * Problem: the "Personalise front & spine" inputs live OUTSIDE the product form and were only
 * attached via the HTML `form=` attribute. The normal Add-to-cart (FormData) picks those up, but
 * Shopify's dynamic checkout button (Buy it now / Apple Pay / Shop Pay / PayPal) only reads inputs
 * physically inside the <form>, so the typed name/initials were dropped on that path.
 * Fix: mirror the values into hidden inputs inside the form and keep them in sync.
 * Loaded from snippets/meta-tags.liquid on product pages only.
 * v3 (28 Sep 2026): hidden diagnostics on every add: _mj_p13n (version, page-load time, keystrokes on this
 * load) and _mj_front_seen / _mj_spine_seen (last non-empty text typed on this load, so a lost name is recoverable).
 * v4 (28 Sep 2026): remembers the typed name/initials on the device (localStorage, 14 days) and restores them,
 * with the matching personalised variant, when the page is reloaded (iOS tab refresh, history, etc).
 * v5 (28 Sep 2026): enforces text <-> variant consistency on every sync (a typed name always buys the personalised
 * variant, an empty box never does), and shows a notice when a page arrived asking for personalisation but the
 * name could not be restored, so nobody is silently moved to the base price.
 * v6 (28 Sep 2026): whenever this script changes the variant (restore, text<->variant guard, or the server-side
 * fallback to the plain variant), it also updates what the customer SEES: the theme's option radio, the price block
 * and the ?variant= in the URL, so the price on screen always matches what checkout will charge (this page has no
 * native variant picker, so the price block is refreshed with the same section fetch the theme itself uses).
 * v7 (28 Sep 2026): price updates instantly from the embedded variant prices and follows the variant whichever script
 * changed it (typing, clearing, restoring); section fetches are debounced and only the newest may apply.
 * v8 (28 Sep 2026): by request, the headline price no longer changes with personalisation. It stays pinned to the
 * base price of the chosen colour; personalisation cost is only shown by the "+£" badge inside the personaliser.
 * (Also pins it when a page arrives with a personalised variant in the URL, so the header never shows £49.99.)
 * v9 (28 Sep 2026): the missing-name notice is shown in German when the page language is German.
 */
(function () {
  var KEYS = [
    { sel: '[data-p13n-front]', name: 'properties[Name on Front]' },
    { sel: '[data-p13n-spine]', name: 'properties[Initials on Spine]' }
  ];

  function findForm() {
    return document.querySelector('product-form form[action*="/cart/add"]') ||
           document.querySelector('form[action*="/cart/add"]');
  }

  function mirrorFor(form, name) {
    var el = null;
    var hidden = form.querySelectorAll('input[type="hidden"][data-mj-mirror]');
    for (var i = 0; i < hidden.length; i++) {
      if (hidden[i].name === name) { el = hidden[i]; break; }
    }
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      el.setAttribute('data-mj-mirror', '1');
      form.appendChild(el);
    }
    return el;
  }

  var LOADED = new Date().toISOString().slice(0, 16).replace('T', ' ');
  var typed = 0;                       // input events on this page load
  var restored = false;                // true when values came back from storage on this load
  var noticeShown = false;
  var meta = document.querySelector('[data-mj-variants]');
  var PRODUCT_ID = meta ? meta.getAttribute('data-product-id') : '';
  var STORE_KEY = 'mj_p13n_' + PRODUCT_ID;
  var VARIANTS = null;
  try { VARIANTS = meta ? JSON.parse(meta.content ? meta.content.textContent : meta.textContent) : null; } catch (e) { VARIANTS = null; }

  function readStore() { try { var v = JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); if (v && v.t && Date.now() - v.t < 14 * 864e5) return v; } catch (e) {} return null; }
  function writeStore(front, spine) { try { if (!front && !spine) localStorage.removeItem(STORE_KEY); else localStorage.setItem(STORE_KEY, JSON.stringify({ front: front, spine: spine, t: Date.now() })); } catch (e) {} }

  // Given the current variant and the typed text, find the variant with the right customisation
  // (last option: "None" / "Front" / "Spine" / "Front & Spine", with or without " Customised").
  function variantForText(currentId, front, spine) {
    if (!VARIANTS || !VARIANTS.length) return null;
    var cur = null, i;
    for (i = 0; i < VARIANTS.length; i++) if (String(VARIANTS[i].id) === String(currentId)) { cur = VARIANTS[i]; break; }
    if (!cur) return null;
    var opts = cur.options || [cur.option1, cur.option2, cur.option3].filter(function (o) { return o != null; });
    var last = opts.length - 1;
    var want = front && spine ? 'Front & Spine' : front ? 'Front' : spine ? 'Spine' : 'None';
    for (i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      var vo = v.options || [v.option1, v.option2, v.option3].filter(function (o) { return o != null; });
      var same = true, k;
      for (k = 0; k < last; k++) if (vo[k] !== opts[k]) { same = false; break; }
      if (!same) continue;
      var lv = String(vo[last] || '');
      if (lv === want || lv === want + ' Customised') return v;
    }
    return null;
  }
  // Keep the URL in step with the variant in the form, but keep the headline price pinned to the BASE (plain) price
  // of the current colour: personalisation is shown only as the small "+£20" badge inside the personaliser.
  var shownId = (function () { try { return new URL(location.href).searchParams.get('variant') || ''; } catch (e) { return ''; } })();
  function setAmount(el, cents) {
    if (!el || cents == null) return;
    var txt = el.textContent, comma = /\d+,\d{2}(\D|$)/.test(txt) && !/\d+\.\d{2}(\D|$)/.test(txt);
    var amt = (cents / 100).toFixed(2); if (comma) amt = amt.replace('.', ',');
    var re = /\d[\d.,]*\d|\d/;
    if (re.test(txt) && txt.replace(re, amt) !== txt) el.textContent = txt.replace(re, amt);
  }
  var pinning = false;
  function pinBasePrice(v) {
    var base = v ? variantForText(v.id, '', '') : null;
    var pe = document.querySelector('[id^="price-"]');
    if (!base || !pe || base.price == null || pinning) return;
    pinning = true;
    try {
      var onSale = base.compare_at_price != null && base.compare_at_price > base.price;
      var box = pe.querySelector('.price'); if (box) box.classList.toggle('price--on-sale', onSale);
      setAmount(pe.querySelector('.price__regular .price-item--regular'), base.price);
      setAmount(pe.querySelector('.price__sale s.price-item--regular'), onSale ? base.compare_at_price : base.price);
      setAmount(pe.querySelector('.price__sale .price-item--sale'), base.price);
    } catch (e) {}
    pinning = false;
  }
  function showVariant(v) {
    if (!v) return;
    shownId = String(v.id);
    try { var url = new URL(location.href); url.searchParams.set('variant', String(v.id)); history.replaceState({}, '', url.toString()); } catch (e) {}
    pinBasePrice(v);
  }
  // if anything else re-renders the price block (colour picker, theme), pin it back to the base price
  (function () {
    var pe = document.querySelector('[id^="price-"]');
    if (!pe || !window.MutationObserver) return;
    new MutationObserver(function () { if (pinning) return; var f = findForm(); var idEl = f && f.querySelector('[name="id"]'); if (idEl) pinBasePrice(variantById(idEl.value)); }).observe(pe, { childList: true, subtree: true, characterData: true });
  })();
  function variantById(id) { if (!VARIANTS) return null; for (var i = 0; i < VARIANTS.length; i++) if (String(VARIANTS[i].id) === String(id)) return VARIANTS[i]; return null; }
  var lastSeen = { front: '', spine: '' }; // last non-empty text seen in each field on this page load
  function sync() {
    var form = findForm();
    if (!form) return;
    // hidden marker (underscore = not shown to the customer): proves the page had the fix when the order was placed
    for (var i = 0; i < KEYS.length; i++) {
      var input = document.querySelector(KEYS[i].sel);
      var value = input ? String(input.value || '').trim() : '';
      mirrorFor(form, KEYS[i].name).value = value;
      var slot = i === 0 ? 'front' : 'spine';
      if (value) lastSeen[slot] = value;
    }
    // keep the variant honest: the typed text decides the customisation, whatever the theme's own scripts did
    var idEl = form.querySelector('[name="id"]');
    if (idEl && VARIANTS) {
      var want = variantForText(idEl.value, lastFront(), lastSpine());
      if (want && String(want.id) !== String(idEl.value)) {
        idEl.value = String(want.id);
        idEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // whoever changed the variant (this script or the theme's customiser), keep the price/URL in step
      if (shownId && String(idEl.value) !== shownId) showVariant(variantById(idEl.value));
      if (!shownId) shownId = String(idEl.value);
    }
    // diagnostics (hidden from the customer): how many keystrokes happened on THIS page load, and the
    // last non-empty text we ever saw in each field, so a lost name can still be recovered from the order
    mirrorFor(form, 'properties[_mj_p13n]').value = 'v9 ' + LOADED + ' typed:' + typed + (restored ? ' restored' : '');
    var fIn = document.querySelector(KEYS[0].sel), sIn = document.querySelector(KEYS[1].sel);
    if (typed > 0) writeStore(fIn ? String(fIn.value || '').trim() : '', sIn ? String(sIn.value || '').trim() : '');
    mirrorFor(form, 'properties[_mj_front_seen]').value = lastSeen.front;
    mirrorFor(form, 'properties[_mj_spine_seen]').value = lastSeen.spine;
  }

  function detach(input) {
    // Stop the visible input submitting on its own (would duplicate the mirror).
    if (input.hasAttribute('form')) input.removeAttribute('form');
    if (input.hasAttribute('name')) {
      input.setAttribute('data-mj-orig-name', input.getAttribute('name'));
      input.removeAttribute('name');
    }
  }

  function lastFront() { var i = document.querySelector(KEYS[0].sel); return i ? String(i.value || '').trim() : ''; }
  function lastSpine() { var i = document.querySelector(KEYS[1].sel); return i ? String(i.value || '').trim() : ''; }

  // A visible notice inside the personaliser (used when the page asked for personalisation but the name is missing)
  function notice(text) {
    var fIn = document.querySelector(KEYS[0].sel); if (!fIn) return;
    var wrap = fIn.closest('.p13n-wrapper') || fIn.parentElement;
    var panel = wrap.querySelector('.p13n-panel'), btn = wrap.querySelector('.p13n-btn');
    if (panel) panel.removeAttribute('hidden');
    if (btn) { btn.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    var n = wrap.querySelector('[data-mj-notice]');
    if (!n) {
      n = document.createElement('div');
      n.setAttribute('data-mj-notice', '1');
      n.setAttribute('role', 'alert');
      n.style.cssText = 'margin:10px 0 0;padding:12px 14px;border-radius:12px;background:#fff7e0;border:1px solid #e0c77a;font-size:14px;line-height:1.4;color:#3b2d05';
      var host = panel ? panel.querySelector('.p13n-card') || panel : wrap;
      host.insertBefore(n, host.firstChild);
    }
    n.textContent = text;
    var hide = function () { if (n.parentNode) n.parentNode.removeChild(n); };
    [KEYS[0].sel, KEYS[1].sel].forEach(function (sel) { var el = document.querySelector(sel); if (el) el.addEventListener('input', hide, { once: true }); });
  }

  function restoreFromStore() {
    var saved = readStore(); if (!saved) return;
    var fIn = document.querySelector(KEYS[0].sel), sIn = document.querySelector(KEYS[1].sel);
    if (!fIn || !sIn) return;
    if ((fIn.value || '').trim() || (sIn.value || '').trim()) return; // customer already typed on this load
    fIn.value = saved.front || ''; sIn.value = saved.spine || '';
    restored = true;
    // open the personaliser so the restored name is visible, not hidden in a collapsed panel
    var wrap = fIn.closest('.p13n-wrapper');
    if (wrap) { var panel = wrap.querySelector('.p13n-panel'), btn = wrap.querySelector('.p13n-btn'); if (panel) panel.removeAttribute('hidden'); if (btn) { btn.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); } }
    // put the form on the matching personalised variant straight away (the theme's own JS may be delayed)
    var form = findForm(); var idEl = form && form.querySelector('[name="id"]');
    var v = idEl ? variantForText(idEl.value, saved.front, saved.spine) : null;
    if (v && idEl && String(v.id) !== String(idEl.value)) { idEl.value = String(v.id); idEl.dispatchEvent(new Event('change', { bubbles: true })); }
    // let the customiser block (if it has already run) pick the values up and update its preview/badges
    [fIn, sIn].forEach(function (el) { el.dispatchEvent(new Event('input', { bubbles: true })); });
    typed = 0;
  }

  var bound = false;
  function bind() {
    var found = 0;
    for (var i = 0; i < KEYS.length; i++) {
      var inputs = document.querySelectorAll(KEYS[i].sel);
      for (var j = 0; j < inputs.length; j++) {
        found++;
        var input = inputs[j];
        if (input.getAttribute('data-mj-bound')) continue;
        input.setAttribute('data-mj-bound', '1');
        detach(input);
        ['input', 'change', 'paste', 'blur', 'keyup', 'focusout'].forEach(function (ev) {
          input.addEventListener(ev, function (e) { if (e.type === 'input') typed++; setTimeout(sync, 0); setTimeout(sync, 60); });
        });
      }
    }
    if (found && !bound) {
      bound = true;
      // Re-sync right before anything in a cart form is pressed or submitted
      // (Add to cart, Buy it now, Apple Pay, Shop Pay, PayPal buttons all live inside it).
      ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (ev) {
        document.addEventListener(ev, function (e) {
          var t = e.target;
          if (t && t.closest && t.closest('form[action*="/cart/add"]')) sync();
        }, true);
      });
      document.addEventListener('submit', function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('form[action*="/cart/add"]')) sync();
      }, true);
      window.addEventListener('mj:customisation-change', function () { setTimeout(sync, 0); });
      window.addEventListener('mj:gift-customisation-change', function () { setTimeout(sync, 0); });
      window.addEventListener('mj:colour-change', function () { setTimeout(sync, 0); });
    }
    if (found && !restored) restoreFromStore();
    if (found) {
      sync();
      // the server rendered the price for the URL's variant; always show the base price instead
      var formP = findForm(); var idP = formP && formP.querySelector('[name="id"]'); if (idP) pinBasePrice(variantById(idP.value));
      if (!noticeShown) {
        noticeShown = true;
        var form0 = findForm(); var id0 = form0 && form0.querySelector('[name="id"]');
        var asked = id0 ? (id0.getAttribute('data-mj-initial-custom') || 'None') : 'None';
        if (asked !== 'None' && !lastFront() && !lastSpine()) {
          var what = asked.replace(' Customised', '');
          var DE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
          if (DE) {
            what = what.replace('Front & Spine', 'Vorderseite & Rücken').replace('Front', 'Vorderseite').replace('Spine', 'Rücken');
            notice('Dieses Journal wurde mit Personalisierung (' + what + ') angelegt, aber der Name fehlt. Gib ihn unten noch einmal ein, oder lass das Feld leer für ein Journal ohne Personalisierung zum Standardpreis.');
          } else {
            notice('This journal was set up with personalisation (' + what + ') but the name is missing. Type it again below to add it back, or leave it blank for a plain journal at the standard price.');
          }
          // the server already fell back to the plain variant; make the price block and URL show that too
          showVariant(variantById(id0.value));
        }
      }
    }
    return found > 0;
  }

  function init() {
    if (bind()) return;
    // Inputs may be rendered late (A/B tools, deferred sections): watch for them for a while.
    var mo = new MutationObserver(function () { if (bind()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
